import { render, staticRenderFns } from "./HsabTransactionChildRow.vue?vue&type=template&id=2f08ad6b&scoped=true"
import script from "./HsabTransactionChildRow.vue?vue&type=script&lang=ts"
export * from "./HsabTransactionChildRow.vue?vue&type=script&lang=ts"
import style0 from "./HsabTransactionChildRow.vue?vue&type=style&index=0&id=2f08ad6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f08ad6b",
  null
  
)

export default component.exports